<template>
  <div class="text-page">
    <vue-headful :title="doctitle" />
    <b-container>
      <b-row>
        <b-col>
          <h1>Archive</h1>
          <p>
            Have a look at the websites from previous years; from the fifth
            Øredev in 2009 up to the one last year. Learn about past speakers,
            programs and themes.
          </p>
          <p>
            You can also watch talks from previous years on the
            <a
              href="https://www.youtube.com/c/%C3%98redevConference"
              target="_blank"
              rel="noopener noreferrer"
              >Øredev YouTube channel</a
            ><br />
            See more of what Øredev can be in the
            <a
              href="https://www.flickr.com/people/199524029@N03/"
              target="_blank"
              rel="noopener noreferrer"
              >picture gallery</a
            >
          </p>

          <div class="d-flex flex-wrap">
            <a
              class="archive-link"
              href="https://archive.oredev.org/2024/index.html#/"
              target="_blank"
              rel="noopener noreferrer"
            >
              2024
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/2023/index.html#/"
              target="_blank"
              rel="noopener noreferrer"
            >
              2023
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/2022/index.html#/"
              target="_blank"
              rel="noopener noreferrer"
            >
              2022
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/2019/home.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2019
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/2018/2018.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2018
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/2017/2017/start.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2017
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/2016/2016.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2016</a
            >
            <!-- This will force a break at sm and below -->
            <div class="w-100 d-none d-sm-block"></div>
            <a
              class="archive-link"
              href="https://archive.oredev.org/2015/2015.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2015
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/oredev2014/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2014
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/oredev2013/2013.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2013
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/oredev2012/2012/start.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2012
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/oredev2011/2011/start.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2011
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/oredev2010/2010.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2010
            </a>
            <a
              class="archive-link"
              href="https://archive.oredev.org/oredev2009/2009/start.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              2009
            </a>
          </div>
        </b-col>
      </b-row>
      <DividerPink />
      <b-row>
        <b-col class="text-center">
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1743156669/2025/Footer_pages/rocket_img.png"
            style="width: 100%; max-width: 416px"
            alt=""
            aria-hidden="true"
          />
        </b-col>
      </b-row>
    </b-container>
    <!-- Mobile Bottom Images -->
    <b-container
      fluid
      class="position-relative d-sm-none"
      style="height: 212vw; overflow: hidden"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_4.png"
        class="position-absolute"
        style="width: 73vw; left: -7vw; bottom: 87vw"
        alt="Delegates sitting on a huge chair at Øredev 2022."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_5.png"
        class="position-absolute"
        style="width: 74vw; right: -7vw; bottom: 6vw"
        alt="Peter Sunde being interviewed on stage at Øredev 2023."
      />
    </b-container>
    <!-- Desktop Bottom Images -->
    <b-container
      fluid
      class="position-relative d-none d-sm-block"
      style="height: 20vw"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_4.png"
        class="position-absolute"
        style="width: 25vw; left: 4vw; bottom: -6vw"
        alt="Delegates sitting on a huge chair at Øredev 2022."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156661/2025/Footer_pages/img_5.png"
        class="position-absolute"
        style="width: 25vw; left: 36vw; bottom: -13vw"
        alt="Peter Sunde being interviewed on stage at Øredev 2023."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_3.png"
        class="position-absolute"
        style="width: 25vw; left: 64vw; bottom: -6vw"
        alt="Delegates smiling while sitting in beach chairs at Øredev 2024."
      />
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Archive",
  data() {
    return {
      doctitle: "Archive - " + this.$store.state.conferencename,
    };
  },
};
</script>

<style lang="scss" scoped>
.archive-link {
  font-family: Lexend, sans-serif;
  padding-right: 24px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0%;
  text-decoration: underline !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Archive.vue